import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Team } from '../models/team';

const routes = {
  create: "/v1/team/create",
  read: teamId => `/v1/team/read/${teamId}`,
  getAllTeams: "/v1/team/list",
  update: teamId => `/v1/team/update/${teamId}`,
  delete: teamId => `/v1/team/hardDelete/${teamId}`,
};

@Injectable({
  providedIn: 'root'
})
export class TeamService {
  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(`${routes.getAllTeams}`);
  }

  create(team: Team): Observable<any> {
    return this.http.post<any>(`${routes.create}`, team.createDto());
  }

  update(team: Team): Observable<any> {
    console.log(team);
    const updateRoute = `${routes.update(team.id)}`;
    return this.http.post<any>(updateRoute, team.updateDto());
  }

  delete(team: Team): Observable<any> {
    const deleteTeamRoute = routes.delete(team.id);
    return this.http.delete<any>(deleteTeamRoute);
  }

  read(team: Team): Observable<any> {
    return this.http.get<any>(routes.read(team.id));
  }
}
